<template>
  <div>
    <BaseCard :heading="$t('appointment.reports')">
      <router-link
        v-for="(report, index) in reports"
        :key="`report-${index}`"
        :class="$style.report"
        :to="`${appointmentId}/report/${report.id}`"
        v-test="'appointment-report'"
      >
        <div :class="$style.reportLeft">
          <BaseIcon
            size="s"
            name="clipboard"
          />
          <div :class="$style.reportText">
            {{ filters.stripHtml(report?.report ?? '') }}
          </div>
        </div>
        <div :class="$style.reportRight">
          <BaseText size="s">{{ filters.dateTime(report.createdAt) }}</BaseText>
        </div>
      </router-link>
    </BaseCard>
  </div>
</template>

<script
  lang="ts"
  setup
>
import filters from '@/filters';
import type { AppointmentReport } from '@/types';

const props = defineProps<{
  appointmentId: number;
  reports: AppointmentReport[];
}>();
</script>

<style
  lang="scss"
  module
>
.report {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: $spacing * 0.5;
  }
}

.reportLeft {
  display: flex;
  align-items: center;
  gap: $spacing * 0.5;
  width: calc(100% - 100px);
}

.reportRight {
  min-width: 100px;
  text-align: right;
  flex-shrink: 0;
}

.reportText {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
